import { v4 as uuidv4 } from 'uuid';

export const SESSION_UUID = uuidv4();
export const TEAM_HEALTH_ROUTE_NAME = 'team-health';

export const PLAYBOOK_ROUTE = 'https://www.atlassian.com/team-playbook/health-monitor';
export const TEAM_SETTING_ROUTE =
  'https://support.atlassian.com/atlassian-account/docs/start-an-atlassian-team/#Understanding-membership-controls';
